import { TEXT_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { JiraSingleLineTextField } from '../fragment';

export const transformSingleLineTextFieldForOptimisticUpdates: DataTransformFn<
	JiraSingleLineTextField,
	string | null
> = (
	existingField: JiraSingleLineTextField,
	fieldData: string | null,
): JiraSingleLineTextField => ({
	...existingField,
	text: !fieldData ? ' ' : fieldData,
});

export const textOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<JiraSingleLineTextField, string | null>;
} = {
	[TEXT_CF_TYPE]: transformSingleLineTextFieldForOptimisticUpdates,
};
